import { render, staticRenderFns } from "./NenTangDichVuList.vue?vue&type=template&id=67a7f900"
import script from "./NenTangDichVuList.vue?vue&type=script&lang=js"
export * from "./NenTangDichVuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports